export default __webpack_public_path__ + "static/media/blue_base.08fef603.png";